module.exports = __webpack_public_path__ + "tenant-variables.b05170f7014cd4c4f2ba49abdc6f19d8.hashedasset.svg";